import './index.css'

const NotFound = () => (
  <div className="no-con">
    <img
      src="https://assets.ccbp.in/frontend/react-js/ebank-not-found-img.png"
      alt="not found"
      className="ni"
    />
    <h1 className="nh">Page Not Found</h1>
    <p className="np">
      We are sorry, the page you requested could not be found
    </p>
  </div>
)

export default NotFound
